<agr-page-detail [pageTitle]="pageTitle$ | async" (backAction)="safeBack()">
  <ng-container actions>
    <button
      mat-button
      class="button--text float-right"
      (click)="openSettingsDialog()"
      data-test="baseline__starting_values"
    >
      <mat-icon class="material-icons-outlined">settings</mat-icon>
      {{ 'feed-profit.detail.starting-values' | translate }}
    </button>
  </ng-container>

  <app-feed-profit-navigation></app-feed-profit-navigation>
  <div class="feed-profit-item__container">
    <router-outlet #o="outlet"></router-outlet>
  </div>
</agr-page-detail>
